export const BookingCounterType = Object.freeze({
	Delayed: 'booking_delayed',
	Unconfirmed: 'booking_unconfirmed',
});
